// Auto-generated from modal.spec.js
export default {
  "tagName": "ui-modal",
  "types": [
    "glass"
  ],
  "variations": [
    "aligned",
    "size"
  ],
  "settings": [
    "closeable"
  ],
  "attributes": [
    "glass",
    "aligned",
    "size",
    "closeable"
  ],
  "optionAttributes": {
    "top-aligned": "aligned",
    "tiny": "size",
    "small": "size",
    "medium": "size",
    "large": "size",
    "big": "size"
  },
  "propertyTypes": {
    "glass": "boolean",
    "aligned": "string",
    "size": "string",
    "closeable": "boolean"
  },
  "allowedValues": {
    "aligned": [
      "top-aligned"
    ],
    "size": [
      "tiny",
      "small",
      "medium",
      "large",
      "big"
    ]
  },
  "defaultValues": {
    "closeable": true
  }
};
